/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import MvnoBlockApiRequest from '../../../interfaces/platform/MvnoBlockApiRequest';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import I18n from '../../../components/Translate/I18n';
import CardHeader from '../../../components/Card/CardHeader';
import { Typography } from '@material-ui/core';
import Card from '../../../components/Card/Card';
import CardBody from '../../../components/Card/CardBody';
import ApiBlockViewDetail from './ApiBlockViewDetail';
import { DateHelper } from '../../../helpers/DateHelper';
import ApiQueryProductPlk from '../../../modules/provisioning/lib/ApiQueryProductPlk';
import XmlView from './XmlView';

interface ApiKsaviViewDetailProps {
    item: MvnoBlockApiRequest;
    onlyApi: boolean | null;
}

class ApiKsaviViewDetail extends PureComponent<ApiKsaviViewDetailProps> {
    apiQueryPlk: ApiQueryProductPlk;

    constructor(props: ApiKsaviViewDetailProps, context: any) {
        super(props, context);
        this.apiQueryPlk = new ApiQueryProductPlk();
    }

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { item, onlyApi } = this.props;
        const variant = 'subtitle2';

        return (
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader>
                            <Typography variant={variant}>
                                <I18n trans="prov:api.api_request" />
                            </Typography>
                        </CardHeader>
                        <CardBody>{XmlView(item.apiRequestQuery)}</CardBody>
                    </Card>
                </GridItem>
                {!onlyApi && this.apiQueryPlk.isQueryProductPlk(item) && (
                    <GridItem xs={12}>
                        <Card>
                            <CardHeader>
                                <Typography variant="body2" color="primary">
                                    <I18n trans="prov:api.api_plk_method_call" valueObject={{ function_name: 'getSubscription' }} />
                                </Typography>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12}>
                                        <Card>
                                            <CardHeader>
                                                <Typography variant="subtitle2">
                                                    <I18n
                                                        trans="prov:api.api_plk_request"
                                                        valueObject={{ count: 1, time: DateHelper.format(item.startProcessAt) }}
                                                    />
                                                </Typography>
                                            </CardHeader>
                                            <CardBody>{XmlView(this.apiQueryPlk.getRequest('PlusgetSubscriptionResponse'))}</CardBody>
                                            <CardHeader>
                                                <Typography variant="subtitle2">
                                                    <I18n
                                                        trans="prov:api.api_plk_response"
                                                        valueObject={{ time: DateHelper.format(item.stopProcessAt) }}
                                                    />
                                                </Typography>
                                            </CardHeader>
                                            <CardBody>{XmlView(this.apiQueryPlk.getResponse('PlusgetSubscriptionResponse'))}</CardBody>
                                        </Card>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader>
                                <Typography variant="body2" color="primary">
                                    <I18n trans="prov:api.api_plk_method_call" valueObject={{ function_name: 'getAccountForSubscription' }} />
                                </Typography>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12}>
                                        <Card>
                                            <CardHeader>
                                                <Typography variant="subtitle2">
                                                    <I18n
                                                        trans="prov:api.api_plk_request"
                                                        valueObject={{ count: 1, time: DateHelper.format(item.startProcessAt) }}
                                                    />
                                                </Typography>
                                            </CardHeader>
                                            <CardBody>{XmlView(this.apiQueryPlk.getRequest('PlusgetAccountForSubscriptionResponse'))}</CardBody>
                                            <CardHeader>
                                                <Typography variant="subtitle2">
                                                    <I18n
                                                        trans="prov:api.api_plk_response"
                                                        valueObject={{ time: DateHelper.format(item.stopProcessAt) }}
                                                    />
                                                </Typography>
                                            </CardHeader>
                                            <CardBody>{XmlView(this.apiQueryPlk.getResponse('PlusgetAccountForSubscriptionResponse'))}</CardBody>
                                        </Card>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                )}
                <GridItem xs={12}>
                    <Card>
                        <CardHeader>
                            <Typography variant={variant}>
                                <I18n trans="prov:api.api_response" />
                            </Typography>
                        </CardHeader>
                        <CardBody>{XmlView(item.apiResponseQuery)}</CardBody>
                    </Card>
                </GridItem>
                {!onlyApi && item.mvnoBlockRequest && item.apiCommand !== 'queryProductPlk' && (
                    <GridItem xs={12}>
                        <ApiBlockViewDetail apiUri={{ uri: item.mvnoBlockRequest }} />
                    </GridItem>
                )}
            </GridContainer>
        );
    }
}

const mapStateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(adescomStyle))(ApiKsaviViewDetail);
